import { useAppStore } from '@/store/app';

export function hasRoutePermission(route) {
  const appStore = useAppStore();
  const permissions = route.meta?.permissions || [];
  return permissions.length === 0 || appStore.hasPermissionIn(permissions);
}
